import React from 'react';
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';

import {Input, LinkButton, Notification, Button, Validator, CardContainer} from 'components/common/uiKit';
import {Language} from 'components/common/app';
import {UserApi, LocaleApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';

class Register extends React.Component {
    constructor(props) {
        super(props);

        this.validator = Validator(props.locale.abbreviation);

        this.state = {
            mobile: '',
            submitLoading: false,
            areaCodes: [],
            selectedArea: ''
        }
    }

    componentDidMount() {
        this.loadAreaCodes()
    }

    loadAreaCodes = () => {
        LocaleApi.GetAreaCodes()
            .then(res => {
                if (res && res.status == 200) {
                    const areaCodes = res.data;
                    const selectedArea = res.data[0].prefix;
                    this.setState({areaCodes, selectedArea});
                }
            })
    };

    inputChange = name => event => {
        this.setState({[name]: parseInt(convertDigitsToStandard(event.target.value))});
    };

    selectChange = event => {
        const selectedArea = event.target.value;

        this.setState({selectedArea});
    };

    registerOnClick = () => {
        const {history, locale} = this.props;
        this.setState({submitLoading: true});

        const {mobile, selectedArea} = this.state;
        const model = {mobile: `${selectedArea}${mobile}`};

        const pageTranslates = locale.translation.Pages.Register.Register;

        if (this.validator.fieldValid(pageTranslates.Mobile) || selectedArea != "0098") {
            UserApi.Register(model)
                .then(res => {
                    if (res && res.status == 200) {
                        const data = res.data;
                        history.push({
                            pathname: 'verify',
                            search: '',
                            state: {...data}
                        });
                    }
                })
                .finally(x => {
                    this.setState({submitLoading: false});
                });
        } else {
            //چون در سازنده ایجاد می شود پس از تغییر زبان این تغییر نمایش داده نمی شود. به همین دلیل خط زیر اضافه شد.
            this.validator.errorMessages.Mobile = 'Incorrect Mobile Format.';

            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({submitLoading: false});
        }
    };

    render() {
        const {mobile, submitLoading, areaCodes, selectedArea} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Register.Register;

        const isPersian = locale.abbreviation == 'fa-IR';

        return (
            <>
                <div className="card card-style" style={{marginTop: 20, direction: 'rtl'}}>
                    <div className='register-page-title' style={{marginTop: 10}}>
                        <h2 className='text-center'>
                            {pageTranslates.Title}
                        </h2>
                    </div>
                    <div className="content mt-2 mb-0">
                        <div className="input-style has-icon input-style-1 d-flex">
                            <i className={`input-icon fa fa-phone color-theme`}></i>
                            <input type="name" type='tel' pattern="[0-9]*" placeholder={pageTranslates.Mobile}
                                   onChange={this.inputChange('mobile')} value={mobile} style={{paddingLeft: 0}}/>
                            <div>
                                <select style={{minWidth: 110}} className='pl-4' onChange={this.selectChange}
                                        value={selectedArea}>
                                    {areaCodes && areaCodes.map((item, index) => {
                                        return (
                                            <option value={item.prefix}>{`${item.country} (${item.code})`}</option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        {selectedArea == "0098" ?
                            this.validator.message(pageTranslates.Mobile, mobile, `${isPersian ? 'mobile' : 'required|mobileEn'}`)
                            :
                            ''
                        }
                        <div className='pt-1 pb-1'>
                            <Button title={pageTranslates.Submit} full type='secondary' loading={submitLoading}
                                    onClick={this.registerOnClick}/>
                        </div>
                    </div>
                </div>
                <CardContainer>
                    <Language/>
                </CardContainer>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Register));
